// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"3ce7cbcb","243":"689b6340","270":"f0f9e3e3","278":"511ff144","555":"72dcc1f3","559":"f84d983f","597":"78f0f383","746":"edec659d","889":"78f427d0"}[chunkId] + ".chunk.js";
};